import { useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "English", flag: "🇨🇦" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "ps", label: "پښتو", flag: "🇦🇫" },
  { code: "da", label: "دری", flag: "🇦🇫" },
];

interface TopLanguageBarProps {
  currentLang: string;
  onLangChange: (code: string) => void;
}

export default function TopLanguageBar({ currentLang, onLangChange }: TopLanguageBarProps) {
  const [showNote, setShowNote] = useState(false);
  const { t } = useTranslation();

  const handleLangClick = (code: string, adminOnly?: boolean) => {
    if (adminOnly) {
      setShowNote(true);
      setTimeout(() => setShowNote(false), 3000);
      return;
    }
    onLangChange(code);
  };

  return (
    <div className="bg-[#1B2838] text-white text-xs relative z-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-9">
        <div className="flex items-center gap-2 text-gray-400">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-global-line text-[#4ECDC4]"></i>
          </span>
          <span className="hidden sm:inline">Canada Afghanistan Foundation</span>
          <span className="sm:hidden">CAF</span>
        </div>
        <div className="flex items-center gap-1">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLangClick(lang.code, lang.adminOnly)}
              className={`px-2 py-1 rounded text-xs whitespace-nowrap cursor-pointer transition-all duration-200 flex items-center gap-1 ${
                currentLang === lang.code
                  ? "bg-[#4ECDC4] text-[#1B2838] font-semibold"
                  : lang.adminOnly
                  ? "text-gray-500 hover:text-gray-300 cursor-not-allowed"
                  : "text-gray-300 hover:text-white hover:bg-white/10"
              }`}
              title={lang.adminOnly ? t("lang.managed") : `Switch to ${lang.label}`}
            >
              <span>{lang.flag}</span>
              <span className="hidden sm:inline">{lang.label}</span>
              <span className="sm:hidden">{lang.code.toUpperCase()}</span>
              {lang.adminOnly && (
                <span className="ml-1 text-[9px] bg-gray-600 text-gray-400 px-1 rounded hidden sm:inline">
                  CMS
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
      {showNote && (
        <div className="absolute top-full right-4 mt-1 bg-[#1B2838] border border-[#4ECDC4]/30 text-gray-300 text-xs px-3 py-2 rounded-lg z-50 max-w-xs">
          <i className="ri-information-line text-[#4ECDC4] mr-1"></i>
          {t("lang.managed")}
        </div>
      )}
    </div>
  );
}
